import Vue from 'vue';
import App from './App.vue'
import store from '@/store'
import router from './router'
import mixins from '@/mixins'
import EventBus from '@/bus.js'
import VueScrollTo from 'vue-scrollto'
import VueFullPage from 'vue-fullpage.js'

import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { fab } from '@fortawesome/free-brands-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fas)
library.add(fab)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.mixin(mixins)
Vue.use(VueScrollTo)
Vue.use(VueFullPage)
Vue.config.productionTip = false

Object.defineProperties(Vue.prototype, {
    $bus: {
        get: function() {
            return EventBus
        }
    }
})

if (process.env.VUE_APP_STAGE !== 'production') {
    Vue.config.devtools = true
}

new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
